import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Mp4"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.8675 10.5L6 6.75H7.5V17.25H6V11.25L6.12 9.75L5.685 11.25L4.5 14.7225L3.315 11.25L2.88 9.75L3 11.25V17.25H1.5V6.75H3L4.155 10.5L4.5 11.985L4.8675 10.5ZM9 17.25H10.5V13.5H13.5C14.3284 13.5 15 12.8284 15 12V8.25C15 7.42157 14.3284 6.75 13.5 6.75H9V17.25ZM21.75 6.75H20.25V12.75H18V6.75H16.5V14.25H20.25V17.25H21.75V14.25H22.5V12.75H21.75V6.75ZM10.5 12H13.5V8.25H10.5V12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Mp4.vue"]]);
